import { ZIP_VALIDATION_REGEX } from '../constants/shell';
import { STATE_LIST_BY_COUNTRY } from '../constants/states';
import { IStateItem } from '../types/shell';
import { isStateRequired } from './country';

export const isValidZip = (zip?: string | null): boolean => ZIP_VALIDATION_REGEX.test(zip ?? '');

export const ADDRESS_LABEL_MAX_LENGTH = 70;

export const isValidAddressLabel = (label?: string | null): boolean =>
  (label ?? '').trim().length <= ADDRESS_LABEL_MAX_LENGTH;

const toStateIndex = (states: IStateItem[]): Map<string, string> =>
  states.reduce((index, { name, two_digit_code }) => {
    index.set(two_digit_code.toLowerCase(), two_digit_code);
    index.set(name.toLowerCase(), two_digit_code);
    return index;
  }, new Map<string, string>());

const STATE_INDEX_BY_COUNTRY: Record<string, Map<string, string>> = Object.entries(STATE_LIST_BY_COUNTRY).reduce(
  (index, [country, states]) => ({ ...index, [country]: toStateIndex(states) }),
  {},
);

export const resolveStateCode = (state?: string | null, country?: string | null): string | null => {
  const key = (state ?? '').trim().toLowerCase();
  const index = STATE_INDEX_BY_COUNTRY[(country ?? '').trim()];

  return (key && index?.get(key)) || null;
};

export const isUnknownState = (state?: string | null, country?: string | null): boolean =>
  isStateRequired((country ?? '').trim()) &&
  (state ?? '').trim().length > 0 &&
  resolveStateCode(state, country) === null;

export const normalizeStateCode = (state?: string | null, country?: string | null): string =>
  resolveStateCode(state, country) ?? (state ?? '').trim();
